export default __webpack_public_path__ + "../staticImages/sprite-ec-2x.png";